"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORT_BUTTON = exports.ORIGINAL_LINK = exports.DETAIL_ITEM_MOBILE_MAX_WIDTH = exports.DETAIL_ITEM_MOBILE_MAX_HEIGHT = exports.DETAIL = void 0;
const ORIGINAL_LINK = exports.ORIGINAL_LINK = 'original-link';
const DETAIL = exports.DETAIL = 'detail';
const REPORT_BUTTON = exports.REPORT_BUTTON = 'report-button';
const DETAIL_ITEM_MOBILE_MAX_WIDTH = exports.DETAIL_ITEM_MOBILE_MAX_WIDTH = 400;
const DETAIL_ITEM_MOBILE_MAX_HEIGHT = exports.DETAIL_ITEM_MOBILE_MAX_HEIGHT = 400;
